export default {
  install(Vue, options) {
    Vue.prototype.editorConf = {
      kkey:'agxxiyg1jdutxaedi814x27cnp8iylepymvoxkllzqghmhdi',
      language_url: "/langs/zh_CN.js",
      language: "zh_CN",
      images_upload_base_path:"http://api.newlong.com.cn",
      images_upload_url: "/api/admin/addPicture",
      automatic_uploads: false,
      images_upload_handler: function (blobInfo, success, failure) {
        // setTimeout(function () {
        //   // no matter what you upload, we will turn it into TinyMCE logo :)
        //   success("http://moxiecode.cachefly.net/tinymce/v9/images/logo.png");
        // }, 2000);
        var xhr, formData;
        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', 'http://api.newlong.com.cn/admin/addPicture2');//第一个参数是请求方式，第二个参数是请求地址，我这里配置的是struts的action，如果是其他（PHP等）的可这样配置：xxx.php
 
        xhr.onload = function () {
            var json;
            if (xhr.status !== 200) {
                failure('HTTP Error: ' + xhr.status);
                return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || json.code !== 200) {
            failure(json.message);
                return;
            }
            success(json.data);
        };
 
        formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        xhr.send(formData);
      },
      init_instance_callback: function (ed) {
        // ed.execCommand("mceImage");
      },
      image_class_list: [
        { title: "None", value: "" },
        { title: "Some class", value: "class-name" }
      ],
      importcss_append: true,
      height: 400,
      width: 1030,
      template_cdate_format: "[CDATE: %m/%d/%Y : %H:%M:%S]",
      template_mdate_format: "[MDATE: %m/%d/%Y : %H:%M:%S]",
      selector: "textarea",
      theme: "modern",
      mobile: {
        theme: "beta-mobile",
        plugins: ["autosave"]
      },
      plugins:
        "print preview fullpage searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor  insertdatetime advlist lists textcolor wordcount imagetools  contextmenu colorpicker textpattern help",
      toolbar1:
      // "formatselect fontsizeselect fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat",
        "formatselect fontsizeselect fontselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist outdent indent  | removeformat",
      image_advtab: true,
      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
      templates: [
        // { title: "Test template 1", content: "Test 1" },
        // { title: "Test template 2", content: "Test 2" }
      ],
      content_css: [
        "//fonts.googleapis.com/css?family=Lato:300,300i,400,400i"
        // "//www.tinymce.com/css/codepen.min.css"
      ],
      content_style: [
        // 'body{min-width:980px;width:980px; padding:5px; margin:auto;font-size:16px;font-family:Lato,"Helvetica Neue",Helvetica,Arial,sans-serif; line-height:1.3; letter-spacing: -0.03em;color:#222} h1,h2,h3,h4,h5,h6 {font-weight:400;margin-top:1.2em} h1 {} h2{} .tiny-table {width:100%; border-collapse: collapse;} .tiny-table td, th {border: 1px solid #555D66; padding:10px; text-align:left;font-size:16px;font-family:Lato,"Helvetica Neue",Helvetica,Arial,sans-serif; line-height:1.6;} .tiny-table th {background-color:#E2E4E7}'
        'body{padding:20px;min-width:980px;width:980px;}  *{padding:0px;margin:0px;}  ul li{list-style: none outside none;}'
      ],
      visual_table_class: "tiny-table"
    }
  }
}